import { getCountry } from './country';
import { getObj, setObj } from './localStorage';
import { updatePlanLinks } from './window';

const getCookieBar = () => (document.getElementsByClassName('cookie-bar') || [])[0];
const getCloseButton = () => document.getElementById('cookie');

const hideBanner = () => {
  const cookieBar = getCookieBar();
  if (cookieBar) {
    cookieBar.setAttribute('style', 'visibility: hidden');
  }
};

const showBanner = () => {
  const cookieBar = getCookieBar();
  if (cookieBar) {
    cookieBar.setAttribute('style', 'visibility: visible');
  }
};

const markCookiesCompleted = (e) => {
  if (e) {
    e.preventDefault();
  }
  setObj('cookies', true);
  hideBanner();
};

export const init = async () => {
  updatePlanLinks();
  await getCountry();
  const closeButton = getCloseButton();
  if (closeButton) {
    closeButton.addEventListener('mousedown', markCookiesCompleted);
    closeButton.addEventListener('touchstart', markCookiesCompleted);
  }

  const cookie = getObj('cookies');

  if (typeof cookie === 'boolean' && cookie) {
    markCookiesCompleted();
  } else {
    showBanner();
  }
};
